import React from 'react';

import { VasList } from '../../../../components/VasList';
import { useOfferContext } from '../../../../context';
import { useAuctionContext } from '../../../../context/AuctionContext';
import { AuctionApplyNewBetHintContainer } from '../AuctionApplyNewBetHintContainer';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { isNotSearcher } from 'shared/utils/isNotSearcher';

export function VASListContainer() {
  const { config } = useApplicationContext();
  const { user, vasList, isFromSuburbanBuilder } = useOfferContext();
  const { currentBet, liquidityPoints } = useAuctionContext();
  const isPerformanceVasPilot = !!config.get<boolean>('isPerformanceVASPilot.Enabled');

  if (!isNotSearcher(user) || isFromSuburbanBuilder || vasList.length === 0 || isPerformanceVasPilot) {
    return null;
  }

  return (
    <VasList
      items={vasList}
      bet={currentBet}
      liquidityPoints={liquidityPoints}
      nextBetTip={<AuctionApplyNewBetHintContainer />}
    />
  );
}
